import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js

const EditBrandPartyDiscount = () => {
    const { id } = useParams(); // Get the ID from the URL
    const navigate = useNavigate();

    // State for holding the discount data
    const [description, setDescription] = useState('');
    const [date, setDate] = useState('');
    const [sno, setSno] = useState(1);
    const [partyCode, setPartyCode] = useState('');
    const [partyName, setPartyName] = useState('');
    const [brandCode, setBrandCode] = useState('');
    const [brandName, setBrandName] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch the discount details on component mount
    useEffect(() => {
        const fetchDiscountDetails = async () => {
            try {
                const response = await fetch(`${BASE_URL}brandpartydiscount/${id}`);
                if (!response.ok) {
                    throw new Error('Error fetching discount details');
                }
                const data = await response.json();
                if (data.status === 'success' && data.data) {
                    const discount = data.data;
                    setDescription(discount.description);
                    setDate(discount.date.split('T')[0]); // To set the date in 'yyyy-mm-dd' format
                    setSno(discount.sno);
                    setPartyCode(discount.party_code);
                    setPartyName(discount.party_name);
                    setBrandCode(discount.brand_code);
                    setBrandName(discount.brand_name);
                } else {
                    setError('Discount not found');
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchDiscountDetails();
    }, [id]);

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        const updatedDiscount = {
            description,
            date,
            sno,
            party_code: partyCode,
            party_name: partyName,
            brand_code: brandCode,
            brand_name: brandName,
        };

        fetch(`${BASE_URL}brandpartydiscount/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedDiscount),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    alert('Discount updated successfully!');
                    navigate('/BrandPartyDiscountList'); // Assuming the route to list is `/BrandPartyDiscountList`
                } else {
                    alert('Error updating discount. Please try again.');
                }
            })
            .catch((error) => console.error('Error updating discount:', error));
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Brand Party Discount</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Brand Party Discount Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <input
                                            type="text"
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            placeholder="Enter discount description"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="date" className="form-label">Date</label>
                                        <input
                                            type="date"
                                            id="date"
                                            className="form-control"
                                            value={date}
                                            onChange={(e) => setDate(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="partyCode" className="form-label">Party Code</label>
                                        <input
                                            type="text"
                                            id="partyCode"
                                            className="form-control"
                                            value={partyCode}
                                            onChange={(e) => setPartyCode(e.target.value)}
                                            placeholder="Enter party code"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="partyName" className="form-label">Party Name</label>
                                        <input
                                            type="text"
                                            id="partyName"
                                            className="form-control"
                                            value={partyName}
                                            onChange={(e) => setPartyName(e.target.value)}
                                            placeholder="Enter party name"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="brandCode" className="form-label">Brand Code</label>
                                        <input
                                            type="text"
                                            id="brandCode"
                                            className="form-control"
                                            value={brandCode}
                                            onChange={(e) => setBrandCode(e.target.value)}
                                            placeholder="Enter brand code"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="brandName" className="form-label">Brand Name</label>
                                        <input
                                            type="text"
                                            id="brandName"
                                            className="form-control"
                                            value={brandName}
                                            onChange={(e) => setBrandName(e.target.value)}
                                            placeholder="Enter brand name"
                                            required
                                        />
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update Discount</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* End Edit Brand Party Discount Form */}
        </div>
    );
};

export default EditBrandPartyDiscount;
